import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=6f423cc9&"
import script from "./TheHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f423cc9')) {
      api.createRecord('6f423cc9', component.options)
    } else {
      api.reload('6f423cc9', component.options)
    }
    module.hot.accept("./TheHeader.vue?vue&type=template&id=6f423cc9&", function () {
      api.rerender('6f423cc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/TheHeader.vue"
export default component.exports